import { render, staticRenderFns } from "./syplus.vue?vue&type=template&id=ed38303a&scoped=true"
import script from "./syplus.vue?vue&type=script&lang=js"
export * from "./syplus.vue?vue&type=script&lang=js"
import style0 from "./syplus.vue?vue&type=style&index=0&id=ed38303a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed38303a",
  null
  
)

export default component.exports